// extracted by mini-css-extract-plugin
export var container = "_o0-0";
export var dotAnimation = "_o0-2";
export var dotsLoading = "_o0-1";